export function parseProveedoresPermitidos(raw) {
  try {
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function normalizeProveedorName(value) {
  return String(value || "").trim().toLowerCase();
}

/** Filtra filas por ProveedorNombre cuando hay lista restringida; sin proveedor no filtra. */
export function filterRowsByProveedorPermitidos(
  rows = [],
  proveedoresPermitidos = [],
) {
  if (!Array.isArray(proveedoresPermitidos) || proveedoresPermitidos.length === 0) {
    return rows;
  }
  const allowed = proveedoresPermitidos.map(normalizeProveedorName);
  return rows.filter((row) => {
    const proveedor = normalizeProveedorName(row?.ProveedorNombre);
    if (!proveedor) return true;
    return allowed.includes(proveedor);
  });
}
